export const LOADING_ORDER = 'LOADING_ORDER'
export const GET_ORDER = 'GET_ORDER'
export const FILTER_ORDER = 'FILTER_ORDER'
export const FILTER_ORDER_BY_PICKER = 'FILTER_ORDER_BY_PICKER'
